module.exports = __webpack_public_path__ + "6480397f49b79fb3571e90aa5cbf9a8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/closeEdit.png
// module id = 748
// module chunks = 0